'use strict';

var _ = require('lodash');
var FareChartTransformationService = function FareChartTransformationService($filter, FareChartDataFactory) {
  function transformToFareChartData(fareLadder, settings) {
    return _.map(fareLadder, function (row) {
      return new FareChartDataFactory().initialize(row, settings).createFareChartData(row, settings);
    });
  }
  function getHostFareLadderData(recommendationEntry, settings) {
    var filteredGroupedRows = _.filter(recommendationEntry.groupedRows, function (groupedRow) {
      return !groupedRow.isLinkedFbc && !groupedRow.isDualRbdFare && (!_.isNil(groupedRow.effectiveBaseFare) || !_.isNil(groupedRow.currentFareBase));
    });
    return transformToFareChartData(filteredGroupedRows, settings);
  }
  function getCompetitorFareLadderData(competitorFareLadder, settings) {
    return transformToFareChartData(competitorFareLadder, settings);
  }
  function getWebFareByCarrierData(webFareData, settings) {
    return transformToFareChartData(webFareData, settings);
  }
  function transformHostFareLadder(recommendationEntry, settings) {
    return {
      fareLadderData: getHostFareLadderData(recommendationEntry, settings)
    };
  }
  function transformCompetitorFareLadder(competitorFareLadder, settings) {
    return {
      fareLadderData: getCompetitorFareLadderData(competitorFareLadder, settings)
    };
  }
  function transformWebFareData(webFareData, settings) {
    return {
      webFareChartData: getWebFareByCarrierData(webFareData, settings)
    };
  }
  return {
    transformHostFareLadder: transformHostFareLadder,
    transformCompetitorFareLadder: transformCompetitorFareLadder,
    transformWebFareData: transformWebFareData
  };
};
FareChartTransformationService.$inject = ['$filter', 'FareChartDataFactory'];
module.exports = FareChartTransformationService;